import React from 'react';
import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';
import { fieldToTextField } from 'formik-mui';
import { isEmpty } from 'lodash';

const FormikAutocomplete = ({ textFieldProps, ...props }) => {
  const {
    form: { setTouched, setFieldValue },
    setAlphaCode,
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  return (
    <Autocomplete
      {...props}
      {...field}
      onChange={(_, value) => {
        if (isEmpty(value)) {
          setFieldValue(name, '');
        } else {
          setFieldValue(name, value.phone);
          setAlphaCode(value.alpha2Code);
        }
      }}
      onBlur={() => setTouched({ [name]: true })}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : option.name
      }
      isOptionEqualToValue={(option, value) => option.phone === value?.phone}
      renderOption={(optionProps, option) => {
        const phone = option.phone.split(',')[0];
        return (
          <li {...optionProps}>
            {option.name} {'+' + phone} {' ' + option.emoji}
          </li>
        );
      }}
      renderInput={(props) => (
        <TextField
          style={{ margin: 0 }}
          {...props}
          {...textFieldProps}
          helperText={helperText}
          error={error}
          inputProps={{
            ...props.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};

export default FormikAutocomplete;
